import useDisclosure from "@/hooks/useDisclosure";
import LinkWrapper from "@/tpo/LinkWrapper";
import Modal from "@/tpo/Modal";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";
import { useTheme } from "styled-components";

import Box from "../Box";
import CustomerPage from "../CustomerPage";
import Divider from "../Divider";
import { LevelFeatures } from "./Levels";

export default function Page({ children }) {
  const theme = useTheme();

  const [opened, { close, open }] = useDisclosure();

  return (
    <CustomerPage
      bg="haze"
      jumbotronProps={{
        bg: "partners",
        title: "Student practitioner application",
        color: "dark"
      }}
    >
      <Box pt={theme.spacing.section.pt} pb={theme.spacing.section.pb} px={[20, 20, "5.5vw"]}>
        <Stack gap={[20, 20, 40]} maxWidth={760} mx="auto">
          <Stack gap={[28]}>
            <Box fontSize={36} lineHeight={["46px"]} fontFamily="gilroyBold">
              Become a Student Practitioner
            </Box>
            <Box fontSize={16} lineHeight={["24px"]} fontFamily="gilroyMedium">
              Fill out the form below to join the Regenerus platform. As a student practitioner,
              you’ll be able to explore our Learning Hub and access test services to support your
              studies.
            </Box>
          </Stack>
          <ButtonV2 as={LinkWrapper} color="dark" withChevron sx={{ mx: "auto" }} onClick={open}>
            view all benefits
          </ButtonV2>
          {children}
        </Stack>
        <Modal
          mode={["fullScreen", "fullScreen", "centered"]}
          maxWidth={714 + 80}
          bg="white"
          closeButton
          headerProps={{
            p: [20, 20, 40]
          }}
          show={opened}
          close={close}
          data-component-name="NotificationModal"
        >
          <Stack maxWidth={640} mx="auto" gap={[24, 24, 40]} pb={80} px={[24]}>
            <Stack gap={[24, 24, 40]}>
              <Box
                fontSize={[24, 24, 28]}
                lineHeight={["24px", "24px", "36px"]}
                fontFamily="gilroyBold"
              >
                Level 4
              </Box>
              <LevelFeatures
                level="Level 4"
                fontSize={[16, 16, 18]}
                lineHeight={["24px", "24px", "28px"]}
              />
            </Stack>
            <Divider />
            <Stack gap={[24, 24, 40]}>
              <Box
                fontSize={[24, 24, 28]}
                lineHeight={["24px", "24px", "36px"]}
                fontFamily="gilroyBold"
              >
                Level 5
              </Box>
              <Stack gap={40}>
                <LevelFeatures
                  level="Level 5"
                  fontSize={[16, 16, 18]}
                  lineHeight={["24px", "24px", "28px"]}
                />
              </Stack>
            </Stack>
            <Divider />
            <Stack gap={[24, 24, 40]}>
              <Box
                fontSize={[24, 24, 28]}
                lineHeight={["24px", "24px", "36px"]}
                fontFamily="gilroyBold"
              >
                Level 6
              </Box>
              <Stack gap={40}>
                <LevelFeatures
                  level="Level 6"
                  fontSize={[16, 16, 18]}
                  lineHeight={["24px", "24px", "28px"]}
                />
              </Stack>
            </Stack>
          </Stack>
        </Modal>
      </Box>
    </CustomerPage>
  );
}
